
import { Cell, CellGroup, Field } from 'vant'
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field
  },
  data () {
    return {
      // 当前IMEI
      nowImei: $cookies.get('imei'),
      // 输入内容
      messageValue: '',
      // 上一次发送成功的消息(避免重复提交)
      sendSuccessMsg: '',
    }
  },
  methods: {
    // 切换设备
    toChangeDevPageFn () {
      this.$router.push('/changeDev')
    },
    // 跳转到首页
    toHomePageFn () {
      this.$router.push('/')
    },
    // 发送语音
    sendAudioFn () {
      if (!this.messageValue) {
        this.$toast('内容不能为空');
        return
      }
      // 如果和上次发送的信息相同则提醒用户
      if (this.sendSuccessMsg === this.messageValue) {
        this.$dialog.confirm({
          title: '',
          message: '该信息您已发送过，需要再次发送吗？'
        }).then(() => {
          // on confirm
          this.sendAudioSubmitFn();
        }).catch(() => {
          // on cancel
        });
      } else {
        this.sendAudioSubmitFn();
      }
    },
    sendAudioSubmitFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '发送中...'
      });
      this.$axios.post('/v3/u/action/UserVoice', { voice: this.messageValue })
        .then(function (response) {
          // console.log(response);
          _this.$toast.clear();
          if (response.data.ret === 0) {
            // _this.$toast.success('发送成功');
            _this.sendSuccessMsg = _this.messageValue;
            _this.$dialog({
              message: '发送成功'
            })
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '发送失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 511);
        })
    }
  }
}
